import React, { FC } from "react";
import { EmptyState, Button } from "@shared/components";

import "./index.scss";

interface PlatformMigrationNoticeProps {
  platform?: string;
  platformUrl?: string;
  supportEmail?: string;
}

const PlatformMigrationNotice: FC<PlatformMigrationNoticeProps> = ({
  platform = "REISift",
  platformUrl = "https://app.reisift.io",
  supportEmail = "support@dataflik.com",
}) => {
  const handleContinue = () => {
    window.open(platformUrl, "_blank", "noopener,noreferrer");
  };

  const title = "This page is no longer available in Dataflik.";
  const subtitle = `As part of platform consolidation, the functionality is available in ${platform}.`;

  const actionComponent = (
    <div className="platform-migration-actions">
      <Button buttonStyle="accent-green" onClick={handleContinue}>
        Continue in {platform}
      </Button>
      <div className="platform-migration-support">
        Questions:{" "}
        <a href={`mailto:${supportEmail}`} className="support-link">
          {supportEmail}
        </a>
      </div>
    </div>
  );

  return (
    <div className="platform-migration-notice">
      <EmptyState title={title} subtitle={subtitle} component={actionComponent} />
    </div>
  );
};

export default PlatformMigrationNotice;
